const comparisons = [
  {
    feature: 'What You Actually Get Paid',
    consignment: 'Retail market value — what a real buyer pays',
    tradeIn: 'Wholesale — what a dealer flips it for',
    privateSale: 'Retail, maybe — if you find the right buyer',
  },
  {
    feature: 'Your Time Investment',
    consignment: 'Drop it off. We handle the rest.',
    tradeIn: 'One trip. Done. (At a cost.)',
    privateSale: 'Weeks of texts, no-shows, and lowballers',
  },
  {
    feature: 'Who Does the Marketing',
    consignment: 'Us — pro photos, multi-platform, real listings',
    tradeIn: 'Nobody. It\'s their car now.',
    privateSale: 'You — Craigslist, Facebook, and hope',
  },
  {
    feature: 'Dealing With Strangers',
    consignment: 'Zero. We screen every buyer.',
    tradeIn: 'Zero. (One of the few upsides.)',
    privateSale: 'Lots. Some are fine. Some are not.',
  },
  {
    feature: 'How Long It Takes',
    consignment: '2–6 weeks average at retail price',
    tradeIn: 'Same day — at a steep discount',
    privateSale: '4–12 weeks, if it sells at all',
  },
  {
    feature: 'Paperwork & Title',
    consignment: 'We handle every form, every signature',
    tradeIn: 'Dealer handles it (in their favor)',
    privateSale: 'You handle it — and hope nothing goes wrong',
  },
];

export default function ConsignmentComparison() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-['Oswald'] text-4xl md:text-5xl font-bold text-[#1C2B1E] mb-4">
            The Honest Comparison
          </h2>
          <div className="w-24 h-1 bg-[#E8B84B] mx-auto mb-6"></div>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#374151' }}>
            Three ways to sell your car. One of them actually works in your favor.
          </p>
        </div>

        <div className="bg-[#F7F5F0] rounded-2xl overflow-hidden border-2 border-[#E8E2D6]">
          <table className="w-full border-collapse" aria-label="Consignment vs Trade-In vs Private Sale comparison">
            <thead>
              <tr className="bg-[#1C2B1E] text-white">
                <th scope="col" className="p-4 text-left w-1/4">
                  <span className="sr-only">Feature</span>
                </th>
                <th scope="col" className="p-4 text-center border-l-2 border-[#E8B84B] w-1/4">
                  <i className="ri-shield-star-line text-2xl text-[#E8B84B] mb-1 block" aria-hidden="true"></i>
                  <span className="font-['Oswald'] text-lg font-bold block">Consignment</span>
                  <span className="text-xs text-[#E8B84B] mt-1 font-medium block">&larr; The smart move</span>
                </th>
                <th scope="col" className="p-4 text-center border-l-2 border-white/20 w-1/4">
                  <i className="ri-exchange-line text-2xl opacity-50 mb-1 block" aria-hidden="true"></i>
                  <span className="font-['Oswald'] text-lg font-bold opacity-75 block">Trade-In</span>
                  <span className="text-xs text-white/60 mt-1 block">Convenient. Costly.</span>
                </th>
                <th scope="col" className="p-4 text-center border-l-2 border-white/20 w-1/4">
                  <i className="ri-user-line text-2xl opacity-50 mb-1 block" aria-hidden="true"></i>
                  <span className="font-['Oswald'] text-lg font-bold opacity-75 block">Private Sale</span>
                  <span className="text-xs text-white/60 mt-1 block">Your problem now.</span>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E8E2D6]">
              {comparisons.map((item, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-[#F7F5F0]'}>
                  <th scope="row" className="p-4 font-semibold text-[#1C2B1E] text-sm text-left align-middle">
                    {item.feature}
                  </th>
                  <td className="p-4 border-l-2 border-[#E8B84B]/30 bg-[#E8B84B]/5 align-middle">
                    <div className="flex flex-col items-center text-center gap-1">
                      <i className="ri-checkbox-circle-fill text-xl text-[#E8B84B]" aria-hidden="true"></i>
                      <p className="text-sm text-[#1C2B1E] font-medium">{item.consignment}</p>
                    </div>
                  </td>
                  <td className="p-4 border-l-2 border-[#E8E2D6] align-middle">
                    <div className="flex flex-col items-center text-center gap-1">
                      <i className="ri-indeterminate-circle-fill text-xl" style={{ color: '#6B7280' }} aria-hidden="true"></i>
                      <p className="text-sm" style={{ color: '#374151' }}>{item.tradeIn}</p>
                    </div>
                  </td>
                  <td className="p-4 border-l-2 border-[#E8E2D6] align-middle">
                    <div className="flex flex-col items-center text-center gap-1">
                      <i className="ri-close-circle-fill text-xl text-red-500" aria-hidden="true"></i>
                      <p className="text-sm" style={{ color: '#374151' }}>{item.privateSale}</p>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-12 text-center bg-[#1C2B1E] rounded-2xl p-10">
          <p className="text-[#E8B84B] font-semibold text-sm uppercase tracking-widest mb-3">The Bottom Line</p>
          <h3 className="font-['Oswald'] text-3xl font-bold text-white mb-4">
            Trade-ins are fast. Private sales are painful.<br />Consignment is how you actually win.
          </h3>
          <p className="text-white/80 mb-8 max-w-xl mx-auto">
            We do the work. You get retail money. No strangers in your driveway, no dealer lowball, no paperwork headaches.
          </p>
          <button className="inline-flex items-center gap-2 bg-[#E8B84B] text-[#1C2B1E] px-8 py-4 rounded-full font-bold hover:bg-[#d4a43a] transition-all whitespace-nowrap cursor-pointer">
            Start Your Consignment
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
